<template>
  <div>
    <exo-table overviewAction :root="_self">
      <exo-form :root="_self">
        <template v-slot:titleTooltip>
          <exo-help-dialog           :color="'black--text'"
          :margin="'m-0'" title="FormationFlying">
            <tooltipFormationFlying />
          </exo-help-dialog>
        </template>
        <exo-input-name :root="_self" />
        <exo-card-form label="Leader">
          <v-row no-gutters justify="start">
            <exo-input-ref-notparametric
              :root="_self"
              name="spacecraft"
              type="spacecraft"
              componentRoute="/numericalspacecraft"
            />
            <exo-input-ref-notparametric
              :root="_self"
              name="initialOrbit"
              type="orbit"
              componentRoute="/numericalorbit"
            />
          </v-row>
          <exo-form-alert
            type="error"
            v-if="
              this.inputs.initialOrbit != null &&
              (this.inputs.initialOrbit.perigeeAltitude > 2000000 ||
                this.inputs.initialOrbit.eccentricity > 2e-3)
            "
          >
            Formation flying only works on LEO near circular orbit (altitude &lt
            2000km and eccentricity &lt 2e-3).
          </exo-form-alert>
        </exo-card-form>
        <exo-card-form
          label="Follower initial conditions relative to formation center, TNW frame"
        >
          <v-row no-gutters>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceX"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceY"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceZ"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceVX"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceVY"
              />
            </v-col>
            <v-col class="px-2">
              <exo-input-double
                :root="_self"
                name="relativePositionFromReferenceVZ"
              />
            </v-col>
          </v-row>
          <exo-form-alert
            type="error"
            v-if="
              Number(this.inputs.alongTrackBoxSize) * 500 <
              this.inputs.relativePositionFromReferenceX
            "
          >
            The initial position of the follower must be inside the control box
            (50% of the along-track box size).
          </exo-form-alert>
        </exo-card-form>
        <exo-card-form label="Formation flying parameters">
          <v-row no-gutters>
            <exo-input-double :root="_self" name="referencePositionX" />
          </v-row>
          <v-row>
            <exo-input-double :root="_self" name="alongTrackBoxSize" />
            <exo-input-double :root="_self" name="radialBoxSize" />
            <exo-input-double :root="_self" name="outOfPlaneBoxSize" />
          </v-row>
        </exo-card-form>
        <exo-card-form label="Simulation parameters">
          <v-row no-gutters justify="start">
            <exo-input-double :root="_self" name="duration" />
            <exo-input-double :root="_self" name="maximumManeuverDuration">
              <exo-help-dialog margin="mt-3" title="Maximum maneuver duration">
                The maximum maneuver duration corresponds to the time available
                for maneuver once the control box edge is reach. A classical
                value which works most of the time is 24h.
              </exo-help-dialog>
            </exo-input-double>
            <exo-input-select
              :multiple="true"
              :root="_self"
              name="perturbations"
            >
              <exo-help-dialog title="Perturbations">
                <tooltipPerturbations />
              </exo-help-dialog>
            </exo-input-select>
          </v-row>
        </exo-card-form>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="this.modalRef" />
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'
import tooltipPerturbations from '../../components/Tooltips/tooltipPerturbations'
import tooltipFormationFlying from '../../components/Tooltips/Toolbox/tooltipFormationFlying'
import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'FormationFlyingSimulationRequest',

  mixins: [formMixin, numericalMixin],

  components: { tooltipPerturbations, tooltipFormationFlying },

  computed: {
    ...mapGetters(['currentMission']),

    perturbationWatcher() {
      return this.inputs.perturbations
    },

    spacecraftWatcher() {
      return this.inputs.spacecraft
    }
  },

  async mounted() {
    await this.refreshOrbits()
    await this.refreshSpacecrafts()
  },

  watch: {
    perturbationWatcher(value) {
      this.inputs.chiefPerturbations = value
    },
    spacecraftWatcher(value) {
      this.inputs.deputySpacecraft = value
    }
  },

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        { value: 'initialOrbit', text: 'Leader orbit', sortable: true },
        {
          value: 'alongTrackBoxSize',
          text:
            'Along-track box size' +
            this.getDefaultUnitLabel('alongTrackBoxSize'),
          sortable: true
        },
        {
          value: 'radialBoxSize',
          text: 'Radial box size' + this.getDefaultUnitLabel('radialBoxSize'),
          sortable: true
        },
        {
          value: 'outOfPlaneBoxSize',
          text:
            'Out-of-plane box size' +
            this.getDefaultUnitLabel('outOfPlaneBoxSize'),
          sortable: true
        },
        {
          value: 'maximumManeuverDuration',
          text:
            'Maximum maneuver duration' +
            this.getDefaultUnitLabel('maximumManeuverDuration'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      enumPropertiesList: this.getEnumProperties(),
      modalRef: { content: [] },
      showModal: false,

      spacecraftsNotParametrics: [],
      orbitsNotParametrics: [],
      inputs: {
        type: 'Formation flying',
        spacecraft: this.getDefaultValue('spacecraft'),
        initialOrbit: this.getDefaultValue('initialOrbit'),
        ephemeridesStepInSeconds: this.getDefaultValue(
          'ephemeridesStepInSeconds'
        ),
        ephemeridesRequested: this.getDefaultValue('ephemeridesRequested'),
        ephemeridesFileTypesRequested: this.getDefaultValue('ephemeridesFileTypesRequested'),
        duration: this.getDefaultValue('duration'),
        chiefPerturbations: [],
        perturbations: [],
        attitudeAndSystemSimulated: this.getDefaultValue(
          'attitudeAndSystemSimulated'
        ),
        deputySpacecraft: this.getDefaultValue('deputySpacecraft'),
        deputyInitialOrbit: this.getDefaultValue('deputyInitialOrbit'),
        relativePositionFromReferenceX: this.getDefaultValue(
          'relativePositionFromReferenceX'
        ),
        relativePositionFromReferenceY: this.getDefaultValue(
          'relativePositionFromReferenceY'
        ),
        relativePositionFromReferenceZ: this.getDefaultValue(
          'relativePositionFromReferenceZ'
        ),
        relativePositionFromReferenceVX: this.getDefaultValue(
          'relativePositionFromReferenceVX'
        ),
        relativePositionFromReferenceVY: this.getDefaultValue(
          'relativePositionFromReferenceVY'
        ),
        relativePositionFromReferenceVZ: this.getDefaultValue(
          'relativePositionFromReferenceVZ'
        ),
        referencePositionX: this.getDefaultValue('referencePositionX'),
        referencePositionY: this.getDefaultValue('referencePositionY'),
        referencePositionZ: this.getDefaultValue('referencePositionZ'),
        referencePositionVX: this.getDefaultValue('referencePositionVX'),
        referencePositionVY: this.getDefaultValue('referencePositionVY'),
        referencePositionVZ: this.getDefaultValue('referencePositionVZ'),
        maximumManeuverDuration: this.getDefaultValue(
          'maximumManeuverDuration'
        ),
        alongTrackBoxSize: this.getDefaultValue('alongTrackBoxSize'),
        radialBoxSize: this.getDefaultValue('radialBoxSize'),
        outOfPlaneBoxSize: this.getDefaultValue('outOfPlaneBoxSize'),
        lof: this.getDefaultValue('lof'),
        linearModelType: this.getDefaultValue('linearModelType'),
        freeFlyingAttitudeMode: this.getDefaultValue('freeFlyingAttitudeMode')
      }
    }
  },

  methods: {
    getCurrentFormType() {
      return 'FormationFlyingSimulationRequest'
    },

    async refreshSpacecrafts() {
      let self = this
      await this.$http
        .get(this.getAPI('spacecraftdefinitions'))
        .then((response) => {
          self.spacecraftsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of spacecrafts. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    async refreshOrbits() {
      let self = this
      await this.$http
        .get(this.getAPI('orbitdefinitions'))
        .then((response) => {
          self.orbitsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of orbits. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getRefList(param) {
      return []
    },
    overview(mission) {
      this.sendMissionEventAfterRedirectionToDashboard(
        'set-current-mission',
        mission
      )
    },

    createMission(mission) {
      if (mission && mission.typeName === this.getCurrentFormType()) {
        this.clearForm()
        this.inputs.type = mission.type
        // set default configuration
        this.inputs.ephemeridesRequested = ['CIRCULAR']
        this.inputs.ephemeridesStepInSeconds = 600
        this.sendFormToServer()
      }
    },

    sendMissionEventAfterRedirectionToDashboard(eventName, mission) {
      this.resetCurrentMission()
      this.$router.push({
        path: '/' + 'formationflyingsimulationdashboard'
      })
      // event send to root because it should be treated by sub components
      // use nextTick to be sure mission components are created and can handle events
      Vue.nextTick(() => {
        this.$root.$emit(eventName, mission)
      })
    },
    resetCurrentMission() {
      // immediate effect
      this.$root.$emit('set-current-mission', null)
    },

    getFieldState(parentObject, fieldName, required) {
      let fieldState = numericalMixin.methods.getFieldState.call(
        this,
        parentObject,
        fieldName,
        required
      )
      if (
        fieldName === 'relativePositionFromReferenceX' &&
        Number(parentObject.relativePositionFromReferenceX) >
          Number(parentObject.alongTrackBoxSize) * 500
      ) {
        fieldState.value = false
      }
      //if (fieldName === "spacecraft" && parentObject.spacecraft != null && parentObject.spacecraft.thruster.thrust > 1e-4
      //) {
      //    fieldState.value = false
      //    fieldState.message = "Spacecraft need a propulsion system with thrust higher than."
      //  }
      //console.log(fieldName)
      //console.log(fieldState)
      if (
        fieldName === 'initialOrbit' &&
        parentObject.initialOrbit != null &&
        (parentObject.initialOrbit.perigeeAltitude > 2000000 ||
          parentObject.initialOrbit.eccentricity > 2e-3)
      ) {
        fieldState.value = false
        fieldState.message =
          'Formation flying only works on LEO near circular orbit (altitude < 2000km and eccentricity < 4e-3).'
      }
      return fieldState
    },
    onSave: function (evt) {
      this.inputs.saving = true
      this.$http
        .put(
          this.getCurrentAPI() + '/' + this.inputs.id,
          this.createObjectFromForm()
        )
        .then((response) => {
          this.inputs.saving = false
          //this.$root.$emit('update-mission-list')
          this.$root.$emit('set-current-mission', response.data) // update fields and current mission
          // redirect to dashboard

          this.$router.push({ path: '/formationflyingsimulationdashboard' })
        })
        .catch((e) => {
          this.inputs.saving = false
          this.displayMessage(
            'Error creating ' + this.inputs.type + '. ',
            e,
            'notification',
            'error'
          )
        })
    }
  }
}
</script>
